import * as React from 'react';
import { Auth0Context } from '../core';
function withAuth0(Component) {
    return class WrappedComponent extends React.Component {
        render() {
            return (React.createElement(Auth0Context.Consumer, null, (value) => React.createElement(Component, Object.assign({}, this.props, { auth: value }))));
        }
    };
}
export default withAuth0;
//# sourceMappingURL=withAuth0.js.map